module.exports = "../study/imgs/maps/Kanagawa/S8/Climate/Temperture/Kanagawa_Temperture_GFDL_RCP26_End.png";